/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable } from "utils/styles/style_helpers";



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default theme =>({
    preferselector: {
    	display: 'flex',
        alignItems: 'center',
        border: `solid ${pxToEm(2)} ${theme.color.neutral.light.swatch}`,
        borderRadius: pxToEm(4),
        padding: `${pxToEm(10)} ${pxToEm(20)}`,
        marginTop: pxToEm(20),
        '&.editable-false':{
            extend: disable
        },
        '& .checkbox':{
            marginRight: pxToEm(15),
            '&.active-false': {
                background: theme.color.neutral.light.swatch
            }
        }
    }
});